import { MantineTheme, Sx } from '@mantine/core';

export const webhookUrlsStyles = (theme: MantineTheme): Sx => {
  return {
    '.segmented-control-lbl-active': {
      color: theme.colors.white[0],
    },
  };
};
